import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { FaqAccordion } from '../components/FaqAccordion';
import { CtaSection } from '../components/CtaSection';
import { WhatsAppIcon } from '../components/icons/WhatsAppIcon';
import { faqs } from '../data/faqs';
import { business } from '../data/site';
import { useLanguage } from '../contexts/LanguageContext';
import { useSeo } from '../hooks/useSeo';
import { buttonClass } from '../utils/styles';
export function Faq() {
  const {
    t,
    lang
  } = useLanguage();
  useSeo({
    title: lang === 'en' ? 'FAQ | Painting, Drywall & Remodeling Questions | M&S Multiservices Dallas' : 'Preguntas Frecuentes | Pintura, Drywall y Remodelación | M&S Multiservices Dallas',
    description: lang === 'en' ? 'Answers about painting costs, free estimates, project timelines, licensing, insurance, warranties, weekend work and the Dallas-Fort Worth areas we serve.' : 'Respuestas sobre costos de pintura, presupuestos gratis, tiempos de proyecto, licencias, seguro, garantías, trabajo en fin de semana y las áreas de Dallas-Fort Worth que atendemos.'
  });
  return <>
      <PageHeader eyebrow={t({
      en: 'Frequently asked questions',
      es: 'Preguntas frecuentes'
    })} title={t({
      en: 'Everything homeowners ask before hiring us',
      es: 'Todo lo que preguntan antes de contratarnos'
    })} description={t({
      en: 'If your question is not here, call or WhatsApp us — we will give you a straight answer, not a sales pitch.',
      es: 'Si tu pregunta no está aquí, llámanos o escríbenos por WhatsApp — te damos una respuesta honesta, no un discurso de venta.'
    })} showActions={false} data-id="element-436" data-mp="2f4vgyxdztrfx" />

      <section className="bg-white" data-id="element-437" data-mp="37uc4phqo4k5t">
        <div className="mx-auto max-w-7xl px-6 py-16 sm:py-20" data-id="element-438" data-mp="37vdj9w6w7osa">
          <div className="grid gap-10 lg:grid-cols-[1.35fr_0.65fr] lg:gap-16" data-id="element-439" data-mp="3cs3wmbrbc6a0">
            <FaqAccordion items={faqs} data-id="element-440" data-mp="2n4i0kzeh3mcd" />

            <aside className="lg:sticky lg:top-32 lg:self-start" data-id="element-441" data-mp="2n5jdl9f1uiwq">
              <div className="rounded-xl bg-navy p-7" data-id="element-442" data-mp="2i66pklcfz5sk">
                <h2 className="font-display text-xl text-white" data-id="element-443" data-mp="2i7hq8calbxfg">
                  {t({
                  en: 'Still have a question?',
                  es: '¿Todavía tienes dudas?'
                })}
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-navy-100" data-id="element-444" data-mp="2s32pw3s6slm1">
                  {t({
                  en: 'We answer the phone during business hours and reply to WhatsApp messages the same day — in English or Spanish.',
                  es: 'Contestamos el teléfono en horario de atención y respondemos WhatsApp el mismo día — en inglés o español.'
                })}
                </p>
                <div className="mt-6 flex flex-col gap-2" data-id="element-445" data-mp="3auvgxsnp3wr4">
                  <a href={business.phoneHref} className={buttonClass('gold', 'md')} data-id="element-446" data-mp="1lew4a1kvbp6q">
                    <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-447" data-mp="1ggks3k73p2lc" />
                    {business.phoneDisplay}
                  </a>
                  <a href={business.whatsappHref} target="_blank" rel="noreferrer" className={buttonClass('whatsapp', 'md')} data-id="element-448" data-mp="3s4zewwwx774s">
                    <WhatsAppIcon className="h-4 w-4" data-id="element-449" data-mp="3idlcag9o9r7f" />
                    WhatsApp
                  </a>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <CtaSection data-id="element-450" data-mp="39f9iy6hf8fba" />
    </>;
}